
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import RadioButton from '@/components/radio-button.vue';
  import PickerDate from '@/components/picker-date.vue';
  import {
    orderSupportmemberOrderSupportStatisticDetail
  } from "@/api/order"
	import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      RadioButton,
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private detailmsg:any = {}
    private aftersales = null
    private aftersaleslList = [
      {
        label:'全部',
        value:null
      },{
        label:'退货退款',
        value:2
      },{
        label:'换货',
        value:1
      },{
        label:'仅退款',
        value:3
      }
    ]
    private refund = null
    private refundList = [
      {
        label:'全部',
        value:null
      },{
        label:'订单金额',
        value:1
      },{
        label:'差价',
        value:2
      },{
        label:'无',
        value:3
      },{
        label:'其他',
        value:4
      }
    ]
    private serialnumber = ''
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;

    private mounted () {
    }
    activated () {
      // console.log(this.pageNo)
      this.pageNo = 1
      this.getList()
    }

    private todetail(row){
      this.$router.push({
        name:'After_Detail',
        query:{
          SupportNo:row.SupportNo||0,
        }
      })
    }
    private changePage(e){
      this.pageNo = e
      this.getList()
    }
    private doSearch(){
      this.pageNo = 1
      this.getList()
    }
    private clearSearch(){
      this.aftersales = null
      this.refund = null
      this.serialnumber = ''
      this.keywords = ''
      this.getList()
    }
    private async getList(){
      this.detailmsg.name = decodeURIComponent(String(this.$route.query.name))
      // console.log(this.detailmsg.name)
      try{
        this.tableloading = true
        let data:any = {
          Id:this.$route.query.Id,
          SupportType:this.aftersales,
          RefundType:this.refund,
          OrderNoKeywords:this.serialnumber,
          MemberKeywords:this.keywords,
          SupportState:this.$route.query.type,
          RoleGrade:this.$route.query.RoleGrade,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let filterTime = String(this.$route.query.filterTime)
				if (filterTime){
					var splitList = filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        // console.log(decodeURIComponent(String(this.$route.query.name)))
        let res = await orderSupportmemberOrderSupportStatisticDetail(data)
        if(res.IsSuccess){
          // console.log(1)
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private exportfile(){
      let url = location.origin + '/pc/orderSupport/memberOrderSupportStatisticDetailExport'
      url += '?Id=' + this.$route.query.Id
      url += '&SupportType=' + (this.aftersales?this.aftersales:'')
      url += '&RefundType=' + (this.refund?this.refund:'')
      url += '&OrderNoKeywords=' + encodeURI(this.serialnumber)
      url += '&MemberKeywords=' + encodeURI(this.keywords)
      url += '&SupportState=' + (this.$route.query.type?this.$route.query.type:'')
      url += '&RoleGrade=' + (this.$route.query.RoleGrade?this.$route.query.RoleGrade:'')
      let filterTime = String(this.$route.query.filterTime)
      if (filterTime){
        var splitList = filterTime.split('/');
        url += '&StartTime=' + splitList[0]
        url += '&EndTime=' + (splitList[1] ? (nextDay(splitList[1],1)) : '')
      }
      // console.log(url)
      window.open(url)
    }
  }
